/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FoodLogDto,
  ListLogsParams,
  ManualLogDto,
  UpdateLogDto
} from '../model';

import { apiFetch } from '../../lib/api-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListLogsUrl = (params?: ListLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/logs?${stringifiedParams}` : `/api/logs`
}

/**
 * Days are bounded in Asia/Bangkok, so a late-night meal counts toward that day.
 * @summary List a day's food logs
 */
export const listLogs = async (params?: ListLogsParams, options?: Parameters<typeof apiFetch>[1]): Promise<FoodLogDto[]> => {

  return apiFetch<FoodLogDto[]>(getListLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLogsQueryKey = (params?: ListLogsParams,) => {
    return [
    `/api/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLogsQueryOptions = <TData = Awaited<ReturnType<typeof listLogs>>, TError = unknown>(params?: ListLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLogs>>> = ({ signal }) => listLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listLogs>>>
export type ListLogsQueryError = unknown


export function useListLogs<TData = Awaited<ReturnType<typeof listLogs>>, TError = unknown>(
 params: undefined |  ListLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLogs>>,
          TError,
          Awaited<ReturnType<typeof listLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLogs<TData = Awaited<ReturnType<typeof listLogs>>, TError = unknown>(
 params?: ListLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLogs>>,
          TError,
          Awaited<ReturnType<typeof listLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLogs<TData = Awaited<ReturnType<typeof listLogs>>, TError = unknown>(
 params?: ListLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a day's food logs
 */

export function useListLogs<TData = Awaited<ReturnType<typeof listLogs>>, TError = unknown>(
 params?: ListLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLogs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLogManualFoodUrl = () => {




  return `/api/logs/manual`
}

/**
 * For the dashboard "add manually" flow; the dish comes from /api/dishes/search.
 * @summary Log a dish manually
 */
export const logManualFood = async (manualLogDto: ManualLogDto, options?: Parameters<typeof apiFetch>[1]): Promise<FoodLogDto> => {

  return apiFetch<FoodLogDto>(getLogManualFoodUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(manualLogDto)
  }
);}





export const getLogManualFoodMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logManualFood>>, TError,{data: ManualLogDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logManualFood>>, TError,{data: ManualLogDto}, TContext> => {

const mutationKey = ['logManualFood'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logManualFood>>, {data: ManualLogDto}> = (props) => {
          const {data} = props ?? {};

          return  logManualFood(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogManualFoodMutationResult = NonNullable<Awaited<ReturnType<typeof logManualFood>>>
    export type LogManualFoodMutationBody = ManualLogDto
    export type LogManualFoodMutationError = void

    /**
 * @summary Log a dish manually
 */
export const useLogManualFood = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logManualFood>>, TError,{data: ManualLogDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logManualFood>>,
        TError,
        {data: ManualLogDto},
        TContext
      > => {
      return useMutation(getLogManualFoodMutationOptions(options), queryClient);
    }
    export const getUpdateLogUrl = (id: string,) => {




  return `/api/logs/${id}`
}

/**
 * For fixing an estimated or mistyped entry. Corrected figures are taken as fact: the item stops being flagged as a guess.
 * @summary Correct a logged item
 */
export const updateLog = async (id: string,
    updateLogDto: UpdateLogDto, options?: Parameters<typeof apiFetch>[1]): Promise<FoodLogDto> => {

  return apiFetch<FoodLogDto>(getUpdateLogUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLogDto)
  }
);}





export const getUpdateLogMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLog>>, TError,{id: string;data: UpdateLogDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLog>>, TError,{id: string;data: UpdateLogDto}, TContext> => {

const mutationKey = ['updateLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLog>>, {id: string;data: UpdateLogDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLog(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLogMutationResult = NonNullable<Awaited<ReturnType<typeof updateLog>>>
    export type UpdateLogMutationBody = UpdateLogDto
    export type UpdateLogMutationError = void

    /**
 * @summary Correct a logged item
 */
export const useUpdateLog = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLog>>, TError,{id: string;data: UpdateLogDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLog>>,
        TError,
        {id: string;data: UpdateLogDto},
        TContext
      > => {
      return useMutation(getUpdateLogMutationOptions(options), queryClient);
    }
    export const getDeleteLogUrl = (id: string,) => {




  return `/api/logs/${id}`
}

/**
 * @summary Delete a mislogged item
 */
export const deleteLog = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteLogUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLogMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLog>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLog>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLog>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLog(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLogMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLog>>>

    export type DeleteLogMutationError = void

    /**
 * @summary Delete a mislogged item
 */
export const useDeleteLog = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLog>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLog>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteLogMutationOptions(options), queryClient);
    }
